import { IconProps } from "../../types/genereal";
import { IconWrapper } from "components/ui/IconWrapper";

export const EditPenIcon = ({
  width = "12",
  height = "12",
  color = "#0860A8",
  opacity = "1",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height} opacity={opacity}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 12 12"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M1.5 10.5V8.375L8.1 1.7875C8.2 1.69583 8.3105 1.625 8.4315 1.575C8.5525 1.525 8.6795 1.5 8.8125 1.5C8.9455 1.5 9.07467 1.525 9.2 1.575C9.32533 1.625 9.43367 1.7 9.525 1.8L10.2125 2.5C10.3125 2.59167 10.3855 2.7 10.4315 2.825C10.4775 2.95 10.5003 3.075 10.5 3.2C10.5 3.33333 10.4772 3.4605 10.4315 3.5815C10.3858 3.7025 10.3128 3.81283 10.2125 3.9125L3.625 10.5H1.5ZM8.8 3.9L9.5 3.2L8.8 2.5L8.1 3.2L8.8 3.9Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
